export const localStorageCart = "awashopBuyerCart";
export const localStorageUserData = "awashopBuyerDetails";
